export const findCachedValueByActionIdentifier = (
    cachedValuesArray = [],
    actionIdentifier
) => {
    return (
        cachedValuesArray.filter(v => v.actionIdentifier === actionIdentifier)[0] || {}
    ).title;
};

export const getCachedFullName = state => {
    return state.cachedFormData.fullName
        ? `${state.cachedFormData.fullName.split(' ')[0]} ${state.cachedFormData.fullName.split(' ').pop()}` //eslint-disable-line
        : state.cachedFormData.firstName && state.cachedFormData.lastName
        ? `${state.cachedFormData.firstName} ${state.cachedFormData.lastName}`
        : ``;
};

export const getCachedFirstName = state => {
    return state.cachedFormData.firstName
        ? state.cachedFormData.firstName
        : state.cachedFormData.fullName
        ? state.cachedFormData.fullName.split(' ')[0]
        : ``;
};
export const getCachedMiddleName = state => {
    if (state.cachedFormData.middleName) {
        return state.cachedFormData.middleName;
    } else if (
        state.cachedFormData.fullName &&
        state.cachedFormData.fullName.split(' ').length > 2
    ) {
        return state.cachedFormData.fullName.split(' ')[1];
    }
};
export const getCachedLastName = state => {
    return state.cachedFormData.lastName
        ? state.cachedFormData.lastName
        : state.cachedFormData.fullName
        ? state.cachedFormData.fullName.split(' ').pop()
        : ``;
};

export const findFormByPathname = pathname => {
    const formRoutes = {
        donationForm: ['/donation/details'],
        volunteer: ['/volunteer/step2', '/volunteer/step3'],
        emailDetailsForm: ['/email'],
        emailDetailsFormMultiRepStep2: ['/email/multiRepStep2'],
        petitionDetailsForm: ['/petition'],
        voteRegistrationStep2Form: ['/voteRegistration/step2'],
        voteRegistrationStep4Form: ['/voteRegistration/step4'],
        voteRegistrationStep5Form: ['/voteRegistration/step5'],
        voteRegistrationStep6Form: ['/voteRegistration/step6'],
        voteRegistrationStep7Form: ['/voteRegistration/step7'],
        voteRegistrationStep8Form: ['/voteRegistration/step8']
    };

    for (let k in formRoutes) {
        if (formRoutes[k].includes(pathname)) {
            return k;
        }
    }
};
